<!--
   Delete / restore window (Yes / No), one per table row.
   Use:
     <DeleteModal
        :modal-id="'deleteCrudModal' + record.id"
        :title="deleteModalTitle"
        :message="deleteModalMessage"
        @confirm="deleteRecord(record.id)"
     />
   The row's button opens it with data-bs-target="#deleteCrudModal{id}", as before.
   Anything put between <DeleteModal> and </DeleteModal> shows under the message.
-->
<template>
   <Teleport to="body">
      <div :id="modalId" class="modal fade" tabindex="-1">
         <div class="modal-dialog">
            <div class="modal-content bg-sa-modal-content">
               <div class="modal-header bg-sa-modal-header">
                  <h4 class="modal-title sa-core-color w-100 text-center">{{ title }}</h4>
                  <button type="button" class="btn-close color-sa-btn-close" data-bs-dismiss="modal"></button>
               </div>
               <div class="modal-body">
                  <p class="sa-core-color w-100 text-center">{{ message }}</p>
                  <slot />
               </div>
               <div class="modal-footer bg-sa-modal-footer">
                  <button @click="$emit('confirm')" type="button" class="btn btn-default btn-danger me-auto" data-bs-dismiss="modal">Yes</button>
                  <button type="button" class="btn btn-default btn-success modal_close color-sa-modal_close" data-bs-dismiss="modal">No</button>
               </div>
            </div>
         </div>
      </div>
   </Teleport>
</template>

<script>
export default {
   name: "DeleteModal",
   props: {
      // Must match the row button's data-bs-target, without the "#"
      modalId: { type: String, required: true },
      title: { type: String, default: "" },
      message: { type: String, default: "" },
   },
   emits: ["confirm"],
};
</script>
